<div class="date-range-container">
  <div class="date-column">
    <h2>Start Date: {{ startDate | date }}</h2>
    <mat-calendar
      *ngIf="renderCalendars"
      [(selected)]="startDate"
      (selectedChange)="onStartSelect($event)"
      [startAt]="startDate"
      [maxDate]="endDate"
      [dateClass]="dateRangeClass"
    ></mat-calendar>
  </div>

  <div class="date-column">
    <h2>End Date: {{ endDate | date }}</h2>
    <mat-calendar
      *ngIf="renderCalendars"
      [(selected)]="endDate"
      (selectedChange)="onEndSelect($event)"
      [minDate]="startDate"
      [startAt]="endDate || startDate"
      [maxDate]="maxDate"
      [dateClass]="dateRangeClass"
    ></mat-calendar>
  </div>
</div>

<div class="date-range-buttons">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button class="primary" (click)="onApply()">Apply</button>
</div>
